import React, { useEffect, useState } from "react";
import tableData from "../DemoTableData";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCompanyDirectoryVendor,
  filterCompanyDirectory,
  removeCompanyTags,
} from "actions/companyDirectoryActions";
import { Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import PaginationSection from "../PaginationSection";
import { ContactsPopUp, TagsPopUp } from "./components";
import { Tooltip } from "@mui/material";
import ServiceOffered from "views/NeevayNetwork/components/tableComponenets/ServiceOffered";
import StaticPopup from "components/StaticPopup";
import BusinessInfoDrawer from "views/NeevayNetwork/components/tableComponenets/BusinessInfoDrawer";
import businessService from "services/businessService";
import { hideContactDetails } from "actions/businessActions";
import tagsService from "services/tagsService";
import Loading from "components/Loading";
import AddVendorForm from "../AddVendorForm";
import VendorInvitationForm from "../VendorInvitationForm";
import VendorFormDrawer from "../VendorFormDrawer";
import axios from "utils/axios";
import { GET_VENDOR_TAXONOMY_URL } from "config/services";
import { updateCompanyDirectory } from "utils/searchUtils";
import VendorCategoryQuickFilter from "./components/VendorCategoryQuickFilter";
import WarningPopup from "components/WarningPopup";
import InternalVendorInfoDrawer from "views/NeevayNetwork/components/tableComponenets/InternalVendorInfoDrawer";
import VendorMakeSelections from "../VendorMakeSelections";

const mapVendorTypeHierarchy = (vendorCategories = [], taxonomyAll = {}) => {
  if (!Array.isArray(vendorCategories) || !vendorCategories.length) {
    return [];
  }

  return vendorCategories.map((typeEntry) => {
    const vendorType = typeEntry?.vendorType || "--";
    const taxonomyType = taxonomyAll?.[vendorType];

    const disciplines = (typeEntry?.disciplines || []).map((discipline) => {
      const matchedDiscipline = taxonomyType?.disciplines?.find(
        (item) => item._id === discipline?.disciplineId,
      );

      const categories = (discipline?.categories || []).map((category) => {
        const matchedCategory = matchedDiscipline?.categories?.find(
          (item) => item._id === category?.categoryId,
        );

        const subCategories = (category?.subCategories || []).map(
          (subCategory) => {
            const matchedSubCategory = matchedCategory?.subCategories?.find(
              (item) => item._id === subCategory?.subCategoryId,
            );

            return {
              id: subCategory?.subCategoryId || "",
              name:
                matchedSubCategory?.name || subCategory?.subCategoryId || "--",
              makeIds: Array.isArray(subCategory?.makeIds)
                ? subCategory.makeIds.map(String)
                : [],
            };
          },
        );

        return {
          id: category?.categoryId || "",
          name: matchedCategory?.name || category?.categoryId || "--",
          subCategories,
        };
      });

      return {
        id: discipline?.disciplineId || "",
        name: matchedDiscipline?.name || discipline?.disciplineId || "--",
        categories,
      };
    });

    return {
      vendorType,
      disciplines,
    };
  });
};

const getVendorMakeSelections = (hierarchy = []) =>
  hierarchy.flatMap((typeEntry) =>
    typeEntry?.vendorType === "Material"
      ? (typeEntry?.disciplines || []).flatMap((discipline) =>
          (discipline?.categories || []).flatMap((category) =>
            (category?.subCategories || [])
              .filter((subCategory) => subCategory?.makeIds?.length)
              .map((subCategory) => ({
                subCategoryId: String(subCategory.id),
                label: subCategory.name,
                makeIds: subCategory.makeIds,
              })),
          ),
        )
      : [],
  );

const buildVendorTypeDisplayData = (vendorCategories = [], taxonomyAll = {}) => {
  const hierarchy = mapVendorTypeHierarchy(vendorCategories, taxonomyAll);
  const vendorTypes = hierarchy
    .map((item) => item?.vendorType)
    .filter(Boolean);
  const categories = hierarchy.flatMap((typeEntry) =>
    (typeEntry?.disciplines || []).flatMap((discipline) =>
      (discipline?.categories || []).map((category) => category?.name || "--"),
    ),
  );

  return {
    summary: vendorTypes.length ? vendorTypes.join(", ") : "--",
    previewCategory: categories[0] || "--",
    hasDetails: hierarchy.length > 0,
    hierarchy,
  };
};

const getDirectoryVendorKey = (vendor = {}) =>
  String(
    vendor?.id ||
      vendor?.vendorId ||
      vendor?.neevaySupplierId ||
      vendor?.supplierId ||
      vendor?._id ||
      "",
  );

const TableComponent = ({
  selectedRows,
  setSelectedRows,
  searchValue,
  invitedVendors,
  maxLimit,
  isSliderView,
  activeTab,
  hideCategoryQuickFilter = false,
}) => {
  const dispatch = useDispatch();
  const vendorsPayload = useSelector((state) => state.companyDirectory);
  const companyDirectory = useSelector((state) => state.companyDirectory);
  const auth = useSelector((state) => state.auth);
  const data = tableData;
  const row = data.row;
  const visibleRows = isSliderView
    ? row.filter((header) => header !== "Actions")
    : row;
  const [column, setColumn] = useState([]);
  const [openAddVendorPopup, setOpenAddVendorPopup] = useState(false);
  // const column = data.column;
  const [currentPage, setCurrentPage] = useState(1);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [tagsPopUp, setTagsPopUp] = useState(false);
  const [tagsData, setTagsData] = useState([]);
  const [myTagsData, setMyTagsData] = useState([]);
  const [viewMoreHeader, setViewMoreHeader] = useState("");
  const [businessInfo, setBusinessInfo] = useState({});
  const [internalVendorData, setInternalVendorData] = useState(null);
  const [openBusinessInfoDrawer, setOpenBusinessInfoDrawer] = useState(false);
  const [showMyTagsLoading, setShowMyTagsLoading] = useState(false);
  const [vendorContactDetails, setVendorContactDetails] = useState([]);
  const [tags, setTags] = useState([]);
  const [tagSelectedId, setTagsSelectedId] = useState("");
  const [editVendorDetails, setEditVendorDetails] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarText, setSnackbarText] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [openApprovalPopup, setOpenApprovalPopup] = useState(false);
  const [pendingVendorData, setPendingVendorData] = useState(null);
  const [approvalFormApi, setApprovalFormApi] = useState(null);
  const [approvalMode, setApprovalMode] = useState(null);
  const [exceptionSuppliers, setExceptionSuppliers] = useState([]);
  const [taxonomyAll, setTaxonomyAll] = useState({});
  const [vendorTypePopupOpen, setVendorTypePopupOpen] = useState(false);
  const [selectedVendorTypeDetails, setSelectedVendorTypeDetails] = useState(
    [],
  );
  const [rfqListPopup, setRfqListPopup] = useState({
    open: false,
    title: "RFQs",
    companyName: "",
    rfqIds: [],
    showInvitedBy: false,
    showSubmittedBy: false,
  });
  const [orderValuePopup, setOrderValuePopup] = useState({
    open: false,
    companyName: "",
    rfqIds: [],
    total: 0,
    zIndex: 50,
  });
  const [documentsPopup, setDocumentsPopup] = useState({
    open: false,
    companyName: "",
    documents: [],
  });
  const [deleteVendorPopup, setDeleteVendorPopup] = useState({
    open: false,
    vendorId: "",
    companyName: "",
  });
  const [deleteVendorLoading, setDeleteVendorLoading] = useState(false);
  const [expandedOrderYears, setExpandedOrderYears] = useState({});
  const showSelectionCheckboxes = ![
    "PENDING",
    "APPROVED_BY_ME",
    "ARCHIVED",
  ].includes(activeTab);

  const userProfile = auth.user;
  const userId = userProfile?.userId;
  const entityId = userProfile?.userEntity?.entityId;
  const isManager =
    String(userProfile?.IAM_role || "").trim().toLowerCase() === "manager";
  const currentUserName = userProfile?.name || "--";
  const vendors = vendorsPayload?.vendors || [];
  const visibleVendors = isManager || activeTab === "APPROVED"
    ? vendors
    : vendors.filter(
        (vendor) =>
          userId && String(vendor?.createdBy) === String(userId),
      );
  const loading = vendorsPayload?.loading;
  const appliedFilters = companyDirectory?.appliedFilters || {};
  const vendorTypeCounts = vendorsPayload?.vendorTypeCounts || {};
  const disciplineCounts = vendorsPayload?.disciplineCounts || {};
  const categoryCounts = vendorsPayload?.categoryCounts || {};
  const subCategoryCounts = vendorsPayload?.subCategoryCounts || {};
  const makeCounts = vendorsPayload?.makeCounts || {};
  // const isRestrictionEnabled = isSliderView && entityId === "ent_1";
  const isRestrictionEnabled = false;
  const selectableVendors = visibleVendors.filter((rowData) => {
    const isInvited = invitedVendors?.some(
      (vendor) =>
        vendor?.supplierId === rowData.vendorId ||
        vendor?.supplierId == rowData.neevaySupplierId,
    );

    // If not slider → no restriction
    if (!isRestrictionEnabled) return !isInvited;

    return (
      !isInvited &&
      (rowData?.isPremium ||
        exceptionSuppliers?.includes(Number(rowData?.neevaySupplierId)))
    );
  });

  const selectedRowKeys = selectedRows?.map(getDirectoryVendorKey).filter(Boolean) || [];
  const selectableVendorKeys = selectableVendors.map(getDirectoryVendorKey).filter(Boolean);
  const isAllSelected =
    selectableVendorKeys.length > 0 &&
    selectableVendorKeys.every((vendorKey) => selectedRowKeys.includes(vendorKey));
  // const vendors = column;
  const totalPages = vendorsPayload?.totalPages;

  const isVendorSelectable = (rowData) => {
    if (!isRestrictionEnabled) return true;

    return (
      rowData?.isPremium ||
      exceptionSuppliers?.includes(Number(rowData?.supplierId))
    );
  };

  const isIntegerHeader = (header) => {
    return (
      header.toUpperCase() === "Awarded (Count)" ||
      header.toUpperCase() === "INVITED COUNT" ||
      header.toUpperCase() === "SUBMITTED COUNT" ||
      header.toUpperCase() === "TOTAL ORDER VALUE" ||
      header.toUpperCase() === "ANNUAL TURNOVER" ||
      header.toUpperCase() === "GST NO."
    );
  };

  const formatCurrency = (value) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(Number(value) || 0);

  const openRfqInNewTab = (rfqId) => {
    if (!rfqId) return;
    window.open(
      `${window.location.origin}/rfqs/${rfqId}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  const getDocumentUrl = (document) =>
    document?.Content || document?.url || document?.fileUrl || "";

  const getDocumentExtension = (fileName = "") => {
    const lastIndex = fileName.lastIndexOf(".");
    return lastIndex !== -1 ? fileName.substring(lastIndex + 1).toLowerCase() : "pdf";
  };

  const viewDocument = (document) => {
    const url = getDocumentUrl(document);
    if (!url) return;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const downloadDocument = (document) => {
    const url = getDocumentUrl(document);
    if (!url) return;

    const link = window.document.createElement("a");
    link.href = url;
    link.download = document?.Name || "vendor-document";
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    window.document.body.appendChild(link);
    link.click();
    window.document.body.removeChild(link);
  };

  const getOrderValueYearBreakdown = (rfqIds = []) => {
    const breakdownMap = new Map();

    rfqIds.forEach((rfq) => {
      const amount = Number(rfq?.amount || 0);
      if (!amount) return;

      const date = rfq?.date ? new Date(rfq.date) : null;
      const hasValidDate = date && !Number.isNaN(date.getTime());
      const year = hasValidDate ? date.getFullYear() : null;
      const month = hasValidDate ? date.getMonth() : null;
      const startYear = hasValidDate ? (month >= 2 ? year : year - 1) : null;
      const endYear = hasValidDate ? startYear + 1 : null;
      const key = hasValidDate ? `${startYear}-${endYear}` : "unknown";

      if (!breakdownMap.has(key)) {
        breakdownMap.set(key, {
          key,
          label: hasValidDate
            ? `Mar ${startYear} - Mar ${endYear}`
            : "Date not available",
          amount: 0,
          rfqs: [],
          sortYear: hasValidDate ? startYear : -1,
        });
      }

      const entry = breakdownMap.get(key);
      entry.amount += amount;
      entry.rfqs.push(rfq);
    });

    return [...breakdownMap.values()].sort((a, b) => b.sortYear - a.sortYear);
  };

  const closeRfqListPopup = () => {
    setRfqListPopup({
      open: false,
      title: "RFQs",
      companyName: "",
      rfqIds: [],
      showInvitedBy: false,
      showSubmittedBy: false,
    });
  };

  const closeOrderValuePopup = () => {
    setOrderValuePopup({
      open: false,
      companyName: "",
      rfqIds: [],
      total: 0,
      zIndex: 50,
    });
    setExpandedOrderYears({});
  };

  const openOrderValueBreakdown = (vendor = {}, options = {}) => {
    const awardedRfqs = Array.isArray(vendor?.awardedRfqs)
      ? vendor.awardedRfqs
      : Array.isArray(vendor?.awardedRfqs?.rfqIds)
        ? vendor.awardedRfqs.rfqIds
        : [];

    setOrderValuePopup({
      open: true,
      companyName: vendor?.Company || vendor?.vendorName || "",
      rfqIds: awardedRfqs,
      total: Number(vendor?.totalOrderValue || 0),
      zIndex: options?.zIndex || 50,
    });
  };

  const closeDocumentsPopup = () => {
    setDocumentsPopup({
      open: false,
      companyName: "",
      documents: [],
    });
  };

  const openDeleteVendorPopup = (rowData) => {
    setDeleteVendorPopup({
      open: true,
      vendorId: rowData?.id || "",
      companyName: rowData?.Company || "",
    });
  };

  const closeDeleteVendorPopup = () => {
    if (deleteVendorLoading) return;
    setDeleteVendorPopup({
      open: false,
      vendorId: "",
      companyName: "",
    });
  };

  const refreshCurrentDirectoryPage = () => {
    dispatch(
      filterCompanyDirectory({
        filterData: appliedFilters,
        searchKey: searchValue,
        pageNum: currentPage || 1,
        userId,
        entityId,
      }),
    );
  };

  const handleDeleteVendor = async () => {
    if (!deleteVendorPopup.vendorId) return;

    try {
      setDeleteVendorLoading(true);
      const response = await dispatch(
        deleteCompanyDirectoryVendor({
          vendorId: deleteVendorPopup.vendorId,
          entityId,
          userId,
          userName: userProfile?.name,
        }),
      );

      if (response?.error) {
        setSnackbarSeverity("error");
        setSnackbarText(response?.message || "Failed to delete vendor.");
        setSnackbarOpen(true);
        return;
      }

      setSnackbarSeverity("success");
      setSnackbarText("Vendor deleted successfully.");
      setSnackbarOpen(true);
      setDeleteVendorPopup({
        open: false,
        vendorId: "",
        companyName: "",
      });
      refreshCurrentDirectoryPage();
    } catch (error) {
      setSnackbarSeverity("error");
      setSnackbarText("Failed to delete vendor. Please try again.");
      setSnackbarOpen(true);
    } finally {
      setDeleteVendorLoading(false);
    }
  };

  const toggleOrderYear = (yearKey) => {
    setExpandedOrderYears((prev) => ({
      ...prev,
      [yearKey]: !prev[yearKey],
    }));
  };

  const fetchSupplierExceptions = async () => {
    try {
      const res = await axios.get(
        `/api/supplier/exceptions?entityId=${entityId}`,
      );
      // console.log("this is exception suppliers response", res);
      setExceptionSuppliers(res?.data?.data || []);
    } catch (err) {
      console.error("Exception supplier fetch failed", err);
    }
  };

  const handleRemoveTag = async (tag) => {
    const payload = {
      entityId: entityId,
      vendorIds: [tagSelectedId],
      userId: userId,
      tagsToRemove: tag,
    };
    const result = await dispatch(removeCompanyTags(payload));
  };

  const handleVendorCategoryFilter = (field, value, isMultiple) => {
    const filterData = updateCompanyDirectory({
      field,
      value,
      isMultiple,
      appliedFilters,
    });

    dispatch(
      filterCompanyDirectory({
        filterData,
        searchKey: searchValue,
        userId,
        entityId,
      }),
    );
  };

  const applyVendorCategoryFilterData = (filterData) => {
    dispatch(
      filterCompanyDirectory({
        filterData,
        searchKey: searchValue,
        userId,
        entityId,
      }),
    );
  };

  const clearAllVendorCategoryFilters = () => {
    const filterData = {
      ...appliedFilters,
      category: [],
      vendorCategory: [],
      vendorMake: [],
    };

    dispatch(
      filterCompanyDirectory({
        filterData,
        searchKey: searchValue,
        userId,
        entityId,
      }),
    );
  };

  const handleSelectAllChange = (e) => {
    // If not in slider view → behave normally (NO LIMIT)
    if (!isSliderView) {
      if (e.target.checked) {
        const selectable = column.filter(
          (rowData) =>
            !invitedVendors?.some(
              (vendor) =>
                vendor?.supplierId === rowData.id ||
                vendor?.supplierId == rowData.supplierId,
            ) && isVendorSelectable(rowData),
        );
        setSelectedRows(selectable);
      } else {
        setSelectedRows([]);
      }
      return;
    }

    // LIMIT CHECK ONLY FOR SLIDER VIEW

    if (e.target.checked) {
      const selectable = column.filter(
        (rowData) =>
          !invitedVendors?.some(
            (vendor) =>
              vendor?.supplierId === rowData.id ||
              vendor?.supplierId == rowData.supplierId,
          ),
      );

      const totalToBeSelected = selectable.length;
      const remaining = maxLimit - invitedVendors.length;

      if (totalToBeSelected > remaining) {
        setSnackbarSeverity("error");
        setSnackbarText(
          `You can select only ${remaining} vendors. RFQ limit is ${maxLimit}.`,
        );
        setSnackbarOpen(true);
        return;
      }

      setSelectedRows(selectable);
    } else {
      setSelectedRows([]);
    }
  };

  const handleSelectRow = (e, rowData) => {
    if (!isVendorSelectable(rowData)) return;
    const rowKey = getDirectoryVendorKey(rowData);
    if (!rowKey) return;

    if (e.target.checked) {
      if (invitedVendors?.length + selectedRows.length >= maxLimit) {
        setSnackbarSeverity("error");
        setSnackbarText(
          `Vendor limit reached. Maximum ${maxLimit} vendors can be added.`,
        );
        setSnackbarOpen(true);
        return;
      }

      setSelectedRows((currentRows) => {
        const isAlreadySelected = currentRows.some(
          (selectedRow) => getDirectoryVendorKey(selectedRow) === rowKey,
        );

        return isAlreadySelected ? currentRows : [...currentRows, rowData];
      });
    } else {
      setSelectedRows((currentRows) =>
        currentRows.filter(
          (selectedRow) => getDirectoryVendorKey(selectedRow) !== rowKey,
        ),
      );
    }
  };

  const handlePageChange = (pageNum) => {
    setCurrentPage(pageNum);
    dispatch(
      filterCompanyDirectory({
        filterData: appliedFilters,
        searchKey: searchValue,
        pageNum,
        userId,
        entityId,
      }),
    );
    // dispatch(searchCompanyDirectoryVendor({ searchKey: searchValue, pageNum }));
  };
  const handleOpenDropDown = (data) => {
    setVendorContactDetails(data);
    setMenuOpen(true);
  };

  const handleClosedTagsPopup = () => {
    setTagsPopUp(false);
    setMyTagsData([]);
    setShowMyTagsLoading(false);
  };

  const handleTagsPopUp = async (values, header, id) => {
    setTagsData(values);
    setTagsPopUp(true);
    setTagsSelectedId(id);
    if (header === "Tags") {
      const payload = await businessService?.fetchMyTagsByVendor({
        userId,
        entityId,
        vendorId: id,
      });
      // const filterTags = values?.filter((item) => tags?.includes(item));
      setMyTagsData(payload?.tags);
      setShowMyTagsLoading(false);
    }
    setViewMoreHeader(header);
  };

  const handleClickOpenBusinessView = async (value) => {
    const vendorData = value?.vendorData || value || {};
    setInternalVendorData({
      ...vendorData,
      vendorTypeHierarchy: value?.vendorTypeHierarchy || vendorData?.vendorTypeHierarchy || [],
      vendorName: vendorData?.vendorName || value?.Company,
      contactDetails: vendorData?.contactDetails || value?.contactDetails,
      location: vendorData?.location || value?.Location,
      serviceOffered: vendorData?.serviceOffered || value?.["Service Offered"],
      gstTurnOverRange: vendorData?.gstTurnOverRange || value?.["Annual Turnover"],
      companyType: vendorData?.companyType || value?.["Company Type"],
      establishedYear: vendorData?.establishedYear || value?.["Year of establishment"],
    });

    if (!value?.onNeevay) {
      setBusinessInfo({});
      setOpenBusinessInfoDrawer(true);
      return;
    }

    const payload = await businessService.fetchBusinessById(value?.supplierId);
    // console.log("this is a payload )))", payload);
    const profile = payload?.profile;
    setBusinessInfo({
      regions: profile.regions,
      selectedcities: profile?.regions?.Selectedcities ?? [],
      country: profile?.regions?.country ?? [],
      state: profile?.regions?.state ?? [],
      businessName: profile?.businessName,
      hightlights: profile?.businessProfile?.businessHeadline,
      description: profile?.businessProfile?.description,
      url: profile?.url,
      establishYear: profile?.businessProfile?.establishYear,
      annualTurnOver: profile?.annualTurnOver,
      serviceOffered: profile.services?.map((service) => service?.serviceName),
      isoCertificates: profile?.businessProfile?.certificates,
      projectNames: payload?.projects?.projects?.map(
        (project) => project?.projectName,
      ),
      projects: payload?.projects?.projects ?? [],
      owners: profile.owners,
      contact:
        profile?.businessProfile?.contact ??
        profile?.businessProfile?.businessMobile,
      supplierId: profile?.supplierId,
      businessMobileNumber: profile?.businessProfile?.businessMobile,
      businessEmail: profile?.businessProfile?.businessEmail,
      vendorCategories: profile?.vendorCategories ?? []
    });
    setOpenBusinessInfoDrawer(true);
  };

  const handleOpenBusinessInfoDrawerClose = () => {
    setOpenBusinessInfoDrawer(false);
    setBusinessInfo({});
    setInternalVendorData(null);
  };

  const handleOpenVendorEditForm = (rowData) => {
    setOpenAddVendorPopup(true);
    setEditVendorDetails(rowData?.vendorData);
  };

  const handleOpenVendorTypePopup = (rowData) => {
    setSelectedVendorTypeDetails(rowData?.vendorTypeHierarchy || []);
    setVendorTypePopupOpen(true);
  };

  const handleOpenApprovalEditForm = (rowData) => {
    setApprovalFormApi(null);

    setPendingVendorData(rowData.vendorData);

    if (activeTab === "PENDING") {
      setApprovalMode("PENDING");
    } else if (activeTab === "APPROVED_BY_ME") {
      setApprovalMode("APPROVED");
    } else if (activeTab === "ARCHIVED") {
      setApprovalMode("ARCHIVED");
    }

    setOpenApprovalPopup(true);
  };

  const getTagsByUserId = async () => {
    const tagsData = await tagsService.fetchTagByUserId({ userId, entityId });
    const tags = tagsData.tags?.filter((tag) => tag !== "");
    setTags(tags);
  };

  useEffect(() => {
    async function loadTaxonomy() {
      try {
        const response = await axios.get(GET_VENDOR_TAXONOMY_URL);
        setTaxonomyAll(response?.data?.data || {});
      } catch (error) {
        console.error("Vendor taxonomy fetch failed", error);
      }
    }

    loadTaxonomy();
  }, []);

  useEffect(() => {
    getTagsByUserId();
    setCurrentPage(vendorsPayload?.currentPage);

    if (visibleVendors?.length >= 1) {
      const exceptionSupplierSet = new Set(exceptionSuppliers.map(Number));

      const getVendorPriority = (vendor) => {
        if (!isRestrictionEnabled) return 0;

        if (vendor?.isPremium) return 2;

        if (exceptionSupplierSet.has(Number(vendor?.neevaySupplierId)))
          return 1;

        if (vendor?.isNeevayVendor) return 1;

        return 0;
      };

      const sortedVendors = [...visibleVendors].sort((a, b) => {
        return getVendorPriority(b) - getVendorPriority(a);
      });
      const columnData = sortedVendors.map((vendor) => {
        const sortedVendors = [...visibleVendors]
          .map((vendor) => ({
            vendor,
            priority: vendor?.isPremium
              ? 3
              : exceptionSupplierSet.has(Number(vendor?.neevaySupplierId))
                ? 2
                : vendor?.isNeevayVendor
                  ? 1
                  : 0,
          }))
          .sort((a, b) => b.priority - a.priority)
          .map((item) => item.vendor);
        // Function to format date
        const formatDate = (dateString) => {
          const date = new Date(dateString);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        };

        const vendorTypeData = buildVendorTypeDisplayData(
          vendor?.vendorCategories,
          taxonomyAll,
        );
        const invitedRfqs = Array.isArray(vendor?.invitedRfqs?.rfqIds)
          ? vendor.invitedRfqs.rfqIds
          : [];
        const submittedRfqs = Array.isArray(vendor?.submittedRfqs?.rfqIds)
          ? vendor.submittedRfqs.rfqIds
          : [];
        const awardedRfqs = Array.isArray(vendor?.awardedRfqs?.rfqIds)
          ? vendor.awardedRfqs.rfqIds
          : [];
        const invitedCount =
          Number(vendor?.invitedRfqs?.count ?? invitedRfqs.length ?? 0) || 0;
        const submittedCount =
          Number(vendor?.submittedRfqs?.count ?? submittedRfqs.length) || 0;
        const awardedCount =
          Number(vendor?.awardedRfqs?.count ?? awardedRfqs.length ?? 0) || 0;
        const totalOrderValue = Number(vendor?.totalOrderValue || 0);

        return {
          id: vendor?.vendorId,
          supplierId: vendor?.neevaySupplierId || null,
          Company: vendor?.vendorName || "",
          contactDetails: vendor?.contactDetails,
          "Contact Details": vendor?.contactDetails?.[0]?.name || "User",
          "Vendor Type": vendorTypeData.summary,
          Tags:
            vendor?.tags?.length >= 1
              ? [...new Set(vendor?.tags?.flatMap((item) => item.tags))]
              : ["--"],
          Location:
            vendor?.location?.length >= 1
              ? vendor?.location[0]?.state
                ? `${vendor?.location[0]?.city},${vendor?.location[0]?.state}`
                : `${vendor?.location[0]?.city}`
              : "--",
          "Service Offered":
            vendor?.servicesOffering?.length >= 1
              ? vendor?.servicesOffering?.map((entry) => entry?.serviceName)
              : ["--"],
          Sector: vendor?.sectors?.length >= 1 ? vendor?.sectors : ["--"],
          "Invited Count": invitedCount || "--",
          invitedRfqs,
          "Submitted Count": submittedCount || "--",
          submittedRfqs,
          "Awarded (Count)": awardedCount || "--",
          awardedRfqs,
          "Total Order Value": totalOrderValue
            ? formatCurrency(totalOrderValue)
            : "--",
          totalOrderValue,
          "Internal Rating":
            vendor?.ratings?.length >= 1
              ? vendor?.ratings[vendor?.ratings?.length - 1]?.rating
              : "--",
          "Internal Notes":
            vendor?.notes?.length >= 1
              ? vendor?.notes[vendor?.notes?.length - 1]?.note
              : "--",
          "Annual Turnover": vendor?.gstTurnOverRange || "--",
          "GST Status": vendor?.gstStatus || "--",
          "GST No.": vendor?.gstNumber || "--",
          "Created Date": vendor?.createdAt
            ? formatDate(vendor?.createdAt)
            : "--",
          "Created By": isManager || String(vendor?.createdBy) !== String(userId)
            ? typeof vendor?.addedBy === "object"
              ? vendor?.addedBy?.name || "--"
              : vendor?.addedBy || "--"
            : currentUserName,
          Documents: Array.isArray(vendor?.attachments) && vendor.attachments.length
            ? vendor.attachments.length
            : "--",
          documents: Array.isArray(vendor?.attachments) ? vendor.attachments : [],
          onNeevay: vendor?.isNeevayVendor || false,
          isPremium: vendor?.isPremium,
          vendorTypePreviewCategory: vendorTypeData.previewCategory,
          vendorTypeHasDetails: vendorTypeData.hasDetails,
          vendorTypeHierarchy: vendorTypeData.hierarchy,
          vendorData: vendor,
          "PAN No.": vendor?.panNumber || "--",
          "Company Type": vendor?.companyType || "--",
          "Year of establishment":
            vendor?.establishedYear || vendor?.yearsInBusiness || "--",
        };
      });
      setColumn(columnData);
    } else {
      setColumn([]);
    }
  }, [vendorsPayload, taxonomyAll, isManager, currentUserName, userId, activeTab]);

  // console.log("vendorsPayload", vendorsPayload)

  useEffect(() => {
    getTagsByUserId();
  }, []);

  useEffect(() => {
    if (isRestrictionEnabled) {
      fetchSupplierExceptions();
    }
  }, [entityId, isSliderView]);

  const isCategoryQuickFilterVisible = !hideCategoryQuickFilter;

  return (
    <section className={isCategoryQuickFilterVisible ? "min-h-full" : "h-full min-h-0"}>
      <div
        className={`relative flex max-w-full flex-col bg-white shadow-md dark:bg-gray-800 sm:rounded-lg ${
          isCategoryQuickFilterVisible ? "min-h-full" : "h-full min-h-0"
        }`}
      >
        {isCategoryQuickFilterVisible && (
          <div className="border-b border-[#ECECE3] p-2">
            <VendorCategoryQuickFilter
              taxonomyAll={taxonomyAll}
              appliedFilters={appliedFilters}
              handleInputChange={handleVendorCategoryFilter}
              applyFilterData={applyVendorCategoryFilterData}
              clearAllVendorCategoryFilters={clearAllVendorCategoryFilters}
              vendorTypeCounts={vendorTypeCounts}
              disciplineCounts={disciplineCounts}
              categoryCounts={categoryCounts}
              subCategoryCounts={subCategoryCounts}
              makeCounts={makeCounts}
              totalCount={vendorsPayload?.totalCount || 0}
            />
          </div>
        )}

        {loading && visibleVendors?.length < 1 && (
          <div className="flex h-[50vh] flex-col items-center justify-center gap-3">
            <div className="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-10 w-10"></div>
            <p className="text-sm font-medium text-gray-600">Almost there! Loading vendors...</p>
          </div>
        )}
        {!loading && !visibleVendors?.length >= 1 && (
          <div className="w-full h-[50vh] flex justify-center items-center">
            <h6>No result found</h6>
          </div>
        )}
        {visibleVendors?.length >= 1 && (
          <>
            <div
              className={`relative flex flex-col overflow-hidden rounded-lg bg-white ${
                isCategoryQuickFilterVisible
                  ? "h-[calc(100vh-190px)] min-h-[520px]"
                  : "min-h-0 flex-1"
              }`}
            >
              {loading && (
                <div className="absolute inset-0 z-[80] flex items-center justify-center rounded-lg bg-white/90 backdrop-blur-[1px]">
                  <div className="flex flex-col items-center gap-3">
                    <div className="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-10 w-10"></div>
                    <p className="text-sm font-semibold text-gray-700">Almost there! Loading vendors...</p>
                  </div>
                </div>
              )}
              {" "}
              <div className="company-directory-table-scroll min-h-0 flex-1 overflow-auto bg-white">
                <table className="w-full table-auto text-xs text-left text-gray-500 dark:text-gray-400 border-separate border-spacing-0">
                  <thead className="sticky top-0 z-[5] text-xs max-w-full text-gray-700 bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                      <th
                        scope="col"
                        className="company-sticky-cell sticky left-0 top-0 z-[6] border-b border-gray-200 bg-gray-50"
                      >
                        {/* <div className="w-4"></div> */}
                        <div
                          className={`flex items-center py-3 bg-gray-50 text-gray-700 font-medium 
                                ${showSelectionCheckboxes ? "px-4 gap-4" : "px-2"}
                              `}
                        >
                          <span className="w-4 shrink-0 text-xs">#</span>
                          <div>
                            {showSelectionCheckboxes && (
                              <input
                                id="checkbox-all"
                                type="checkbox"
                                checked={isAllSelected}
                                onChange={handleSelectAllChange}
                                className="w-4 h-4 bg-gray-100 border-gray-300 rounded text-[#D65A22] checked:border-[#D65A22] checked:bg-[#D65A22] focus:outline-none focus:ring-2 focus:ring-[#F1C9B6] focus:ring-offset-0"
                              />
                            )}
                            <label htmlFor="checkbox-all" className="sr-only">
                              Checkbox for all
                            </label>
                          </div>

                          <p className="text-xs">Company Name</p>
                        </div>
                        {/* <span>
                        {isAllSelected ? (
                          // Render a tick mark if all checkboxes are selected
                          <span>&#10003;</span>
                        ) : (
                          // Render a minus sign if one or more checkboxes are selected
                          <span>&#8722;</span>
                        )}
                      </span> */}
                      </th>
                      {/* <th
                      scope="col"
                      className="font-medium sticky left-10 top-0 z-10 bg-gray-50 text-gray-700"
                    >
                      <div
                        style={{
                          boxShadow: "5px -2px 13.1px 0px rgba(0, 0, 0, 0.05)",
                        }}
                      >
                        <p className="px-4 py-3">COMPANY</p>
                      </div>
                    </th> */}

                      {visibleRows.slice(1).map((header, index) => (
                        <th
                          key={index}
                          scope="col"
                          className={`px-4 py-3 text-gray-700 sticky top-0 z-[5] border-b border-gray-200 bg-gray-50 font-medium w-[100px] ${
                            isIntegerHeader(header) ? "text-right" : "text-left"
                          }`}
                        >
                          <p
                            className={`truncate text-xs ${
                              isIntegerHeader(header)
                                ? "text-right"
                                : "text-left"
                            }`}
                          >
                            {header}
                          </p>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {column?.map((rowData, rowIndex) => (
                      <tr
                        key={rowIndex}
                        // className="border-b group transition  "
                        className={`border-b group transition dark:border-gray-600 hover:bg-[#FFF9F5] dark:hover:bg-gray-700
                            ${!isVendorSelectable(rowData) && isRestrictionEnabled ? "opacity-60" : ""}
                          `}
                      >
                        <td
                          className="company-sticky-cell sticky left-0 z-[4] w-4 border-b border-gray-100 text-xs bg-white group-hover:bg-[#FFF9F5] transition"
                        >
                          <div className="flex items-center px-4 py-3 gap-4">
                            <span className="w-4 shrink-0 text-xs text-gray-500">
                              {rowIndex + 1}
                            </span>
                            {showSelectionCheckboxes &&
                              !invitedVendors?.some(
                                (vendor) =>
                                  vendor?.supplierId === rowData.id ||
                                  vendor?.supplierId == rowData.supplierId,
                              ) && (
                                <div className="flex items-center">
                                  {!isVendorSelectable(rowData) &&
                                  isRestrictionEnabled ? (
                                    <Tooltip
                                      title="This vendor is restricted and cannot be selected"
                                      arrow
                                      placement="top"
                                    >
                                      <span>
                                        <input
                                          type="checkbox"
                                          disabled
                                          className="w-4 h-4 bg-gray-100 border-gray-300 rounded text-[#D65A22] checked:border-[#D65A22] checked:bg-[#D65A22] focus:outline-none focus:ring-2 focus:ring-[#F1C9B6] focus:ring-offset-0 opacity-40 cursor-pointer"
                                        />
                                      </span>
                                    </Tooltip>
                                  ) : (
                                    <input
                                      type="checkbox"
                                      disabled={!isVendorSelectable(rowData)}
                                      onChange={(e) =>
                                        handleSelectRow(e, rowData)
                                      }
                                      checked={selectedRows.some(
                                        (selectedRow) =>
                                          getDirectoryVendorKey(selectedRow) ===
                                          getDirectoryVendorKey(rowData),
                                      )}
                                      onClick={(e) => e.stopPropagation()}
                                      className="w-4 h-4 bg-gray-100 border-gray-300 rounded text-[#D65A22] checked:border-[#D65A22] checked:bg-[#D65A22] focus:outline-none focus:ring-2 focus:ring-[#F1C9B6] focus:ring-offset-0 disabled:opacity-40 disabled:cursor-not-allowed"
                                    />
                                  )}
                                </div>
                              )}

                            <div className="flex min-w-0 flex-1 items-center">
                              <div className="mr-2 min-w-0 flex-1">
                                {rowData.onNeevay ? (
                                  <div className="flex min-w-0 items-center gap-2">
                                    <Tooltip
                                      title="Edit Vendor"
                                      placement="top"
                                      arrow
                                    >
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();

                                          if (
                                            activeTab === "PENDING" ||
                                            activeTab === "APPROVED_BY_ME" ||
                                            activeTab === "ARCHIVED"
                                          ) {
                                            handleOpenApprovalEditForm(rowData);
                                          } else {
                                            handleOpenVendorEditForm(rowData);
                                          }
                                        }}
                                      >
                                        <svg
                                          className="w-4 h-4 text-gray-500 hover:text-[#D97745]"
                                          focusable="false"
                                          fill="currentColor"
                                          aria-hidden="true"
                                          viewBox="0 0 24 24"
                                          data-testid="ModeEditOutlineIcon"
                                          tabindex="-1"
                                          title="ModeEditOutline"
                                        >
                                          <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 5.63l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41"></path>
                                        </svg>
                                      </button>
                                    </Tooltip>
                                    <button
                                      className="min-w-0 flex-1 text-left text-[#0057D9] transition hover:text-[#003F9E] hover:underline"
                                      // style={{ color: "#1A56DB" }}
                                      onClick={() =>
                                        handleClickOpenBusinessView(rowData)
                                      }
                                    >
                                      <p
                                        className="truncate text-xs font-medium"
                                        title={rowData.Company}
                                      >
                                        {rowData.Company}
                                      </p>
                                    </button>
                                  </div>
                                ) : (
                                  <div className="flex min-w-0 items-center gap-2">
                                    <Tooltip
                                      title="Edit Vendor"
                                      placement="top"
                                      arrow
                                    >
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();

                                          if (
                                            activeTab === "PENDING" ||
                                            activeTab === "APPROVED_BY_ME" ||
                                            activeTab === "ARCHIVED"
                                          ) {
                                            handleOpenApprovalEditForm(rowData);
                                          } else {
                                            handleOpenVendorEditForm(rowData);
                                          }
                                        }}
                                      >
                                        <svg
                                          className="w-4 h-4 text-gray-500 hover:text-[#D97745]"
                                          focusable="false"
                                          fill="currentColor"
                                          aria-hidden="true"
                                          viewBox="0 0 24 24"
                                          data-testid="ModeEditOutlineIcon"
                                          tabindex="-1"
                                          title="ModeEditOutline"
                                        >
                                          <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 5.63l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41"></path>
                                        </svg>
                                      </button>
                                    </Tooltip>
                                    <button
                                      type="button"
                                      className="min-w-0 flex-1 truncate text-left text-[#0057D9] transition hover:text-[#003F9E] hover:underline"
                                      onClick={() =>
                                        handleClickOpenBusinessView(rowData)
                                      }
                                    >
                                      <p
                                        className="truncate text-xs font-medium"
                                        title={rowData.Company}
                                      >
                                        {rowData.Company}
                                      </p>
                                    </button>
                                  </div>
                                )}
                              </div>
                              <div className="flex shrink-0 items-center">
                              {rowData.onNeevay ? (
                                <Tooltip
                                  title="Vendor is part of Vendor Marketplace & hence has up to date Information"
                                  placement="top"
                                  arrow
                                >
                                  <div
                                    style={{
                                      borderRadius: "3px",
                                      border: "0.5px solid #039400",
                                      background: "#E1FFDE",
                                      padding: "0 4px", // You can adjust the padding as needed
                                    }}
                                    className="flex items-center mr-1"
                                  >
                                    <span className="text-black font-inter font-semibold text-xs ">
                                      N
                                    </span>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="5"
                                      height="5"
                                      viewBox="0 0 5 5"
                                      fill="none"
                                    >
                                      <circle
                                        cx="2.5"
                                        cy="2.5"
                                        r="2.5"
                                        fill="#039400"
                                      />
                                    </svg>
                                  </div>
                                </Tooltip>
                              ) : (
                                <></>
                              )}
                              {rowData?.isPremium ? (
                                <Tooltip
                                  title="Vendor has been Verified for their Services & Contact Details"
                                  placement="top"
                                  arrow
                                >
                                  <img
                                    src="https://storagereponeevaydevcdn.blob.core.windows.net/business/Verified_image_nn.png"
                                    alt="verified"
                                    className={`h-[18px] w-[18px] ml-1`}
                                  />
                                </Tooltip>
                              ) : (
                                <div className="w-[18px]"></div>
                              )}

                              {invitedVendors?.some(
                                (vendor) =>
                                  vendor?.supplierId === rowData.id ||
                                  vendor?.supplierId == rowData.supplierId,
                              ) && (
                                <Tooltip
                                  title="This vendor is already invited in RFQ"
                                  placement="top"
                                  arrow
                                >
                                  <img
                                    className={`${rowData?.isPremium ? "mr-2" : "mr-1"}`}
                                    src="https://storagereponeevaydevcdn.blob.core.windows.net/business/InvitedIcon.svg"
                                    alt="invited"
                                    style={{ width: "24px", height: "18px" }} // Fixed dimensions here
                                  />
                                </Tooltip>
                              )}
                              </div>
                            </div>
                          </div>
                        </td>
                        {visibleRows.slice(1).map((header, colIndex) => (
                          <td key={colIndex} className="w-4 border-b border-gray-100">
                            {header === "Location" && (
                              <div className="flex items-center max-w-[150px] px-4 py-2">
                                <p
                                  className="truncate text-xs text-gray-500 font-medium"
                                  title={rowData[header]}
                                >
                                  {rowData[header]}
                                </p>
                              </div>
                            )}
                            {(header === "Contact Details" ||
                              header === "Default Contact") && (
                              <div
                                className="group flex items-center justify-start gap-2 w-[180px] cursor-pointer px-4 py-2 hover:bg-[#FFF7F2]"
                                onClick={() =>
                                  handleOpenDropDown(rowData["contactDetails"])
                                }
                              >
                                {rowData["contactDetails"]?.length > 1 ? (
                                  <svg
                                    aria-hidden="true"
                                    className="hidden w-4 h-4 text-gray-500 dark:text-gray-400 md:block shrink-0"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
                                  </svg>
                                ) : (
                                  <svg
                                    fill="currentColor"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512"
                                    className="hidden w-3 h-3 text-gray-500 dark:text-gray-400 md:block shrink-0"
                                  >
                                    <path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z" />
                                  </svg>
                                )}
                                <p
                                  className="truncate text-xs text-gray-500 font-medium "
                                  title={rowData[header]}
                                >
                                  {rowData[header]}
                                </p>
                                <div className="hidden transition-opacity duration-1000 ease-in-out">
                                  {/* <div> */}
                                  <div className=" text-gray-400 text-xs px-2  py-1 flex items-center justify-between cursor-pointer">
                                    Vendor details
                                  </div>
                                </div>
                              </div>
                            )}

                            {header === "Vendor Type" && (
                              <div className="max-w-[200px] px-4 py-2 flex">
                                <p
                                  className="truncate text-xs text-gray-700 font-medium"
                                  title={rowData[header]}
                                >
                                  {rowData[header]}
                                </p>
                                {rowData?.vendorTypeHasDetails && (
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleOpenVendorTypePopup(rowData)
                                    }
                                    className="pl-2 text-[11px] font-medium text-[#B45309] underline transition hover:text-[#7C2D12]"
                                  >
                                    +more
                                  </button>
                                )}
                              </div>
                            )}

                            {(header === "GST Status" ||
                              header === "Added By" ||
                              header === "Created By" ||
                              header === "Company Type" ||
                              header === "PAN No." ||
                              header === "Year of establishment") && (
                              <div className="flex items-center max-w-[120px] px-4 py-2">
                                <p
                                  className="truncate text-xs text-gray-500 font-medium"
                                  title={rowData[header]}
                                >
                                  {rowData[header]}
                                </p>
                              </div>
                            )}

                            {header === "Created Date" && (
                              <div className="flex items-center max-w-[150px] px-4 py-2">
                                <p
                                  className="truncate text-xs text-gray-500 font-medium"
                                  title={rowData[header]}
                                >
                                  {rowData[header]}
                                </p>
                              </div>
                            )}

                            {header === "Documents" && (
                              <div className="flex items-center justify-center w-[110px] px-4 py-2">
                                {rowData?.documents?.length ? (
                                  <Tooltip title="View vendor documents" placement="top" arrow>
                                    <button
                                      type="button"
                                      className="inline-flex items-center gap-1.5 rounded-full border border-blue-200 bg-blue-50 px-2.5 py-1 text-xs font-semibold text-blue-700 hover:border-blue-300 hover:bg-blue-100"
                                      onClick={() =>
                                        setDocumentsPopup({
                                          open: true,
                                          companyName: rowData.Company,
                                          documents: rowData.documents,
                                        })
                                      }
                                    >
                                      <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
                                        <path d="M14 2v6h6" />
                                      </svg>
                                      {rowData.Documents}
                                    </button>
                                  </Tooltip>
                                ) : (
                                  <p className="text-xs font-medium text-gray-400">--</p>
                                )}
                              </div>
                            )}

                            {header === "Actions" && (
                              <div className="flex items-center justify-center w-[90px] px-4 py-2">
                                {activeTab === "PENDING" ||
                                activeTab === "APPROVED_BY_ME" ? (
                                  <p className="text-xs font-medium text-gray-400">--</p>
                                ) : (
                                  <Tooltip title="Delete vendor" placement="top" arrow>
                                    <button
                                      type="button"
                                      className="inline-flex h-6 w-6 items-center justify-center rounded-full border border-red-100 bg-red-50 text-red-600 transition hover:border-red-200 hover:bg-red-100"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        openDeleteVendorPopup(rowData);
                                      }}
                                    >
                                      <svg
                                        className="h-4 w-4"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      >
                                        <path d="M3 6h18" />
                                        <path d="M8 6V4h8v2" />
                                        <path d="M19 6l-1 14H6L5 6" />
                                        <path d="M10 11v6" />
                                        <path d="M14 11v6" />
                                      </svg>
                                    </button>
                                  </Tooltip>
                                )}
                              </div>
                            )}

                            {(header === "Invited Count" ||
                              header === "Submitted Count" ||
                              header === "Awarded (Count)") && (
                              <div className="flex items-center justify-end ml-auto w-[130px] max-w-[130px] overflow-hidden px-4 py-2">
                                {(() => {
                                  const rfqList =
                                    header === "Invited Count"
                                      ? rowData?.invitedRfqs
                                      : header === "Submitted Count"
                                        ? rowData?.submittedRfqs
                                        : rowData?.awardedRfqs;
                                  const popupTitle =
                                    header === "Invited Count"
                                      ? "Invited RFQs"
                                      : header === "Submitted Count"
                                        ? "Submitted RFQs"
                                        : "Awarded RFQs";
                                  const isInvitedMetric =
                                    header === "Invited Count";
                                  const metricClasses = isInvitedMetric
                                    ? "border-blue-200 bg-blue-50 text-blue-700 hover:border-blue-300 hover:bg-blue-100"
                                    : "border-emerald-200 bg-emerald-50 text-emerald-700 hover:border-emerald-300 hover:bg-emerald-100";
                                  const iconColor = isInvitedMetric
                                    ? "#1D4ED8"
                                    : "#047857";

                                  return rfqList?.length ? (
                                    <button
                                      type="button"
                                      className={`group inline-flex max-w-full items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold shadow-xl transition-all hover:shadow-md ${metricClasses}`}
                                      onClick={() =>
                                        setRfqListPopup({
                                          open: true,
                                          title: popupTitle,
                                          companyName: rowData.Company,
                                          rfqIds: rfqList,
                                          showInvitedBy: isInvitedMetric,
                                          showSubmittedBy:
                                            header === "Submitted Count",
                                        })
                                      }
                                      title={`View ${popupTitle.toLowerCase()}`}
                                    >
                                      <svg
                                        width="13"
                                        height="13"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M3 4.5H13M3 8H13M3 11.5H8.5"
                                          stroke={iconColor}
                                          strokeWidth="1.6"
                                          strokeLinecap="round"
                                        />
                                      </svg>
                                      <span className="shrink-0">
                                        {rowData[header]}
                                      </span>
                                      <span className="shrink-0 text-[10px] font-medium opacity-75">
                                        RFQs
                                      </span>
                                    </button>
                                  ) : (
                                    <p className="text-xs font-medium text-gray-400">
                                      {rowData[header]}
                                    </p>
                                  );
                                })()}
                              </div>
                            )}

                            {header === "Total Order Value" && (
                              <div className="flex items-center justify-end ml-auto max-w-[180px] px-4 py-2">
                                {rowData?.totalOrderValue ? (
                                  <button
                                    type="button"
                                    className="group inline-flex items-center gap-1.5 rounded-full border border-amber-200 bg-amber-50 px-2.5 py-1 text-xs font-semibold text-amber-800 shadow-sm transition-all hover:border-amber-300 hover:bg-amber-100 hover:shadow-md"
                                    onClick={() => openOrderValueBreakdown(rowData)}
                                    title="View order value breakdown"
                                  >
                                    <svg
                                      width="13"
                                      height="13"
                                      viewBox="0 0 16 16"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M5 3H11M5 6H11M5 3C7.75 3 9.5 4.2 9.5 6.25C9.5 8.3 7.75 9.5 5 9.5L10.5 13"
                                        stroke="#92400E"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                    <span>{rowData[header]}</span>
                                  </button>
                                ) : (
                                  <p className="text-xs font-medium text-gray-400">
                                    {rowData[header]}
                                  </p>
                                )}
                              </div>
                            )}

                            {(header === "Annual Turnover" ||
                              header === "GST No.") && (
                              <div className="flex items-center justify-end ml-auto max-w-[140px] px-4 py-2">
                                <p
                                  className="text-xs text-gray-500 font-medium"
                                  title={rowData[header]}
                                >
                                  {rowData[header]}
                                </p>
                              </div>
                            )}

                            {header === "Internal Rating" && (
                              <div className="flex items-center px-4 py-2">
                                {[1, 2, 3, 4, 5].map((num, index) => (
                                  <svg
                                    key={index}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="15"
                                    height="15"
                                    viewBox="0 0 15 15"
                                    fill={
                                      index < rowData[header]
                                        ? "#FFDD2C"
                                        : "#626D81"
                                    }
                                  >
                                    <path d="M7.5 0.421828C7.37955 0.164044 7.12503 0 6.84551 0C6.56599 0 6.31375 0.164044 6.19103 0.421828L4.72983 3.52226L1.46654 4.01908C1.19385 4.06126 0.966602 4.25812 0.882518 4.52762C0.798434 4.79712 0.866625 5.09474 1.06207 5.29394L3.42999 7.71007L2.87096 11.1245C2.8255 11.4058 2.93913 11.6917 3.1641 11.858C3.38908 12.0244 3.68678 12.0455 3.93221 11.9119L7.00064 10.3067L10.0692 11.9119C10.3146 12.0455 10.6123 12.0268 10.8373 11.858C11.0623 11.6893 11.1759 11.4058 11.1305 11.1245L10.5692 7.71007L12.9371 5.29394C13.1425 5.09474 13.213 4.79712 13.1266 4.52762C13.0403 4.25812 12.8153 4.06126 12.5416 4.01908L9.27605 3.52226L7.81484 0.421828Z" />
                                  </svg>
                                ))}
                              </div>
                            )}
                            {/* we already create tags show more  pop up so we add service offered and sector   */}
                            {(header === "Tags" || header === "Sector") &&
                              rowData[header]?.length >= 1 && (
                                <p className="truncate  font-medium text-gray-500 text-[12px] px-4 py-2">
                                  {header === "Sector" ? (
                                    <span class="text-xs font-medium pr-2.5 py-0.5">
                                      {rowData[header][0] === ""
                                        ? "--"
                                        : rowData[header][0]}
                                    </span>
                                  ) : rowData[header][0] !== "--" ? (
                                    <span class="bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-300">
                                      {rowData[header][0]}
                                    </span>
                                  ) : (
                                    <span class="text-xs font-medium pr-2.5 py-0.5">
                                      --
                                    </span>
                                  )}
                                  {rowData[header]?.length > 1 && (
                                    <span
                                      onClick={() => {
                                        setShowMyTagsLoading(true);
                                        handleTagsPopUp(
                                          rowData[header],
                                          header,
                                          rowData?.id,
                                        );
                                      }}
                                      className="underline cursor-pointer  "
                                    >{`+${
                                      rowData[header]?.length - 1
                                    } more`}</span>
                                  )}
                                </p>
                              )}

                            {header === "Service Offered" && (
                              <p className="truncate  font-medium text-black text-[12px] px-4 py-2">
                                <ServiceOffered values={rowData[header]} />
                              </p>
                            )}

                            {header === "Internal Notes" && (
                              <div className="flex items-center w-[120px] px-4 py-2">
                                <p
                                  className="truncate text-gray-500 font-medium text-[12px]"
                                  title={rowData[header]}
                                >
                                  {rowData[header]}
                                </p>
                              </div>
                            )}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
                <style>
                  {`
                        .company-directory-table-scroll::-webkit-scrollbar {
                          height: 6px;
                          width: 6px;
                        }

                        .company-directory-table-scroll::-webkit-scrollbar-thumb {
                          background-color: #949494; 
                        }

                        .company-sticky-cell {
                          position: sticky;
                        }

                        .company-sticky-cell::after {
                          content: "";
                          position: absolute;
                          top: 0;
                          right: -10px;
                          width: 10px;
                          height: 100%;
                          z-index: 2;
                          pointer-events: none;
                          background: linear-gradient(90deg, rgba(15, 23, 42, 0.12), rgba(15, 23, 42, 0));
                        }
                      `}
                </style>
              </div>
              <div className="relative z-[7] border-t border-gray-200 bg-white">
                <PaginationSection
                  totalPages={totalPages}
                  currentPage={currentPage}
                  handlePageChange={handlePageChange}
                />
              </div>
            </div>
          </>
        )}
      </div>

      {/* this is pop  up code here */}
      {isMenuOpen && (
        <ContactsPopUp
          vendorContactDetails={vendorContactDetails}
          setMenuOpen={setMenuOpen}
        />
      )}
      {/* {tagsPopUp && (
        <TagsPopUp
          header={viewMoreHeader}
          tags={tagsData}
          setTagsPopUp={setTagsPopUp}
        />
      )} */}
      <BusinessInfoDrawer
        handleOpenBusinessInfoDrawerClose={handleOpenBusinessInfoDrawerClose}
        values={businessInfo}
        openBusinessInfoDrawer={openBusinessInfoDrawer && Boolean(businessInfo?.businessName)}
        internalVendorData={businessInfo?.businessName ? internalVendorData : null}
        onViewRfq={openRfqInNewTab}
        onViewOrderValue={(vendor) =>
          openOrderValueBreakdown(vendor, { zIndex: 10050 })
        }
      />
      <InternalVendorInfoDrawer
        open={openBusinessInfoDrawer && !businessInfo?.businessName}
        vendor={internalVendorData}
        widthClassName="md:max-w-[88vw] xl:max-w-[80vw]"
        onClose={handleOpenBusinessInfoDrawerClose}
        onViewRfq={openRfqInNewTab}
        onViewOrderValue={(vendor) =>
          openOrderValueBreakdown(vendor, { zIndex: 10050 })
        }
      />
      <StaticPopup
        openModal={tagsPopUp}
        handleClose={() => handleClosedTagsPopup()}
        header={viewMoreHeader}
      >
        {viewMoreHeader === "Tags" ? (
          <div>
            {showMyTagsLoading ? (
              <div className=" w-full h-10 flex justify-center items-center">
                <svg
                  aria-hidden="true"
                  class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span class="sr-only">Loading...</span>
              </div>
            ) : (
              myTagsData?.length >= 1 && (
                <div className="mb-12">
                  <p className="text-[#353522] font-bold mb-4">My Tags</p>
                  <div className="flex flex-wrap gap-3">
                    {myTagsData?.map((tag, index) => (
                      <span class="bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-100">
                        {tag}
                        <button
                          className="ml-1 rounded-[14px] p-1 hover:bg-green-200"
                          onClick={() => {
                            setMyTagsData((preVal) =>
                              preVal.filter((tags) => tags !== tag),
                            );
                            handleRemoveTag(tag);
                          }}
                        >
                          <svg
                            width="8"
                            height="8"
                            viewBox="0 0 8 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_4643_3749)">
                              <path
                                d="M4.72632 3.9999L7.44366 1.28256C7.49269 1.2352 7.5318 1.17855 7.55871 1.11592C7.58562 1.05328 7.59978 0.985915 7.60037 0.917748C7.60096 0.849581 7.58797 0.781979 7.56216 0.718886C7.53635 0.655793 7.49823 0.598472 7.45002 0.550269C7.40182 0.502066 7.3445 0.463946 7.28141 0.438132C7.21831 0.412319 7.15071 0.399329 7.08254 0.399922C7.01438 0.400514 6.94701 0.414676 6.88438 0.441582C6.82174 0.468488 6.76509 0.507599 6.71773 0.556633L4.00039 3.27398L1.28305 0.556633C1.18622 0.463116 1.05654 0.411369 0.921931 0.412539C0.787323 0.413708 0.65856 0.467701 0.563375 0.562886C0.468189 0.658072 0.414197 0.786835 0.413027 0.921443C0.411857 1.05605 0.463604 1.18573 0.557121 1.28256L3.27447 3.9999L0.557121 6.71725C0.508087 6.7646 0.468977 6.82125 0.442071 6.88389C0.415165 6.94652 0.401002 7.01389 0.40041 7.08206C0.399818 7.15022 0.412807 7.21782 0.43862 7.28092C0.464434 7.34401 0.502554 7.40133 0.550757 7.44953C0.59896 7.49774 0.656281 7.53586 0.719374 7.56167C0.782467 7.58749 0.850069 7.60048 0.918236 7.59988C0.986403 7.59929 1.05377 7.58513 1.1164 7.55822C1.17904 7.53132 1.23569 7.49221 1.28305 7.44317L4.00039 4.72583L6.71773 7.44317C6.81456 7.53669 6.94424 7.58844 7.07885 7.58727C7.21346 7.5861 7.34222 7.5321 7.43741 7.43692C7.53259 7.34173 7.58658 7.21297 7.58775 7.07836C7.58892 6.94375 7.53718 6.81407 7.44366 6.71725L4.72632 3.9999Z"
                                fill="#0E9F6E"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_4643_3749">
                                <rect width="8" height="8" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </button>
                      </span>
                    ))}
                  </div>
                </div>
              )
            )}
            <div>
              <p className="text-[#353522] font-bold mb-4">Company Tags</p>
              <div className="flex flex-wrap gap-3">
                {tagsData?.map((tag, index) => (
                  <span class="bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-100">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-wrap gap-3">
            {tagsData?.map((tag, index) => (
              <span class="bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-100">
                {tag}
              </span>
            ))}
          </div>
        )}
      </StaticPopup>

      <StaticPopup
        openModal={rfqListPopup.open}
        handleClose={closeRfqListPopup}
        header={`${rfqListPopup.title}${rfqListPopup.companyName ? ` - ${rfqListPopup.companyName}` : ""}`}
        width={"3xl"}
      >
        {rfqListPopup.rfqIds?.length ? (
          <div className="max-h-[360px] space-y-2 overflow-y-auto pr-1">
            {rfqListPopup.rfqIds.map((item, index) => (
              <button
                key={`${item?.rfqId}-${index}`}
                type="button"
                onClick={() => openRfqInNewTab(item?.rfqId)}
                className="flex w-full items-center justify-between rounded-md border border-gray-200 bg-white px-4 py-3 text-left hover:border-blue-200 hover:bg-blue-50"
              >
                <span className="min-w-0 pr-3">
                  <span className="block text-sm font-semibold text-blue-700">
                    RFQ #{item?.rfqId}
                  </span>
                  <span className="block truncate text-xs text-gray-600">
                    {item?.name || "Untitled RFQ"}
                  </span>
                  {item?.businessDivision && (
                    <span className="mt-0.5 block truncate text-[11px] text-gray-500">
                      Category: {item.businessDivision}
                    </span>
                  )}
                  {rfqListPopup.showInvitedBy && (
                    <span className="mt-0.5 block truncate text-[11px] text-gray-500">
                      Invited by: {item?.requesterName || "--"}
                    </span>
                  )}
                  {rfqListPopup.showSubmittedBy && (
                    <span className="mt-0.5 block truncate text-[11px] text-gray-500">
                      Submitted by: {item?.submittedBy || "--"}
                    </span>
                  )}
                </span>
                <span className="text-xs text-gray-500">
                  {item?.date
                    ? new Date(item.date).toLocaleDateString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })
                    : "--"}
                </span>
              </button>
            ))}
          </div>
        ) : (
          <p className="text-sm text-gray-500">
            No RFQs found for this vendor.
          </p>
        )}
      </StaticPopup>

      <StaticPopup
        openModal={orderValuePopup.open}
        handleClose={closeOrderValuePopup}
        header={`Total Order Value${orderValuePopup.companyName ? ` - ${orderValuePopup.companyName}` : ""}`}
        width={"5xl"}
        zIndex={orderValuePopup.zIndex}
      >
        {orderValuePopup.rfqIds?.length ? (
          <div className="max-h-[420px] overflow-y-auto pr-1">
            <div className="mb-4 rounded-lg border border-blue-100 bg-blue-50/60 p-4">
              <div className="mb-3 flex items-center justify-between">
                <p className="text-sm font-bold text-gray-900">
                  Year-wise Summary
                </p>
                <p className="text-xs text-gray-500">Based on award date</p>
              </div>
              <div className="space-y-2">
                {getOrderValueYearBreakdown(orderValuePopup.rfqIds).map(
                  (item) => (
                    <div key={item.key} className="rounded-md bg-white">
                      <button
                        type="button"
                        onClick={() => toggleOrderYear(item.key)}
                        className="flex w-full items-center justify-between px-3 py-2 text-left"
                      >
                        <span className="text-sm font-medium text-gray-700">
                          {item.label}
                        </span>
                        <span className="text-sm font-bold text-gray-900">
                          {formatCurrency(item.amount)}
                        </span>
                      </button>
                      {expandedOrderYears[item.key] && (
                        <div className="border-t border-blue-50 px-3 pb-3">
                          <div className="space-y-1 pt-2">
                            {item.rfqs.map((rfq, rfqIndex) => (
                              <button
                                key={`${item.key}-${rfq?.rfqId}-${rfqIndex}`}
                                type="button"
                                onClick={() => openRfqInNewTab(rfq?.rfqId)}
                                className="flex w-full items-center justify-between rounded-md px-2 py-2 text-left hover:bg-blue-50"
                              >
                                <span className="min-w-0 pr-3">
                                  <span className="block text-xs font-semibold text-blue-700">
                                    RFQ #{rfq?.rfqId}
                                  </span>
                                  <span className="block truncate text-xs text-gray-600">
                                    {rfq?.name || "Untitled RFQ"}
                                  </span>
                                  {rfq?.businessDivision && (
                                    <span className="block truncate text-[11px] text-gray-500">
                                      Category: {rfq.businessDivision}
                                    </span>
                                  )}
                                </span>
                                <span className="whitespace-nowrap text-xs font-semibold text-gray-900">
                                  {formatCurrency(rfq?.amount || 0)}
                                </span>
                              </button>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ),
                )}
              </div>
            </div>

            <div className="overflow-x-auto rounded-lg border border-gray-200">
              <div className="grid min-w-[760px] grid-cols-[90px_1.25fr_1fr_1.25fr_120px] gap-3 border-b border-gray-200 bg-gray-50 px-4 py-3 text-xs font-semibold uppercase text-gray-500">
                <span>RFQ ID</span>
                <span>RFQ Name</span>
                <span>Category</span>
                <span>Project</span>
                <span className="text-right">Amount</span>
              </div>
              {orderValuePopup.rfqIds.map((item, index) => (
                <button
                  key={`${item?.rfqId}-${index}`}
                  type="button"
                  onClick={() => openRfqInNewTab(item?.rfqId)}
                  className="grid min-w-[760px] w-full grid-cols-[90px_1.25fr_1fr_1.25fr_120px] gap-3 border-b border-gray-100 px-4 py-3 text-left last:border-b-0 hover:bg-blue-50"
                >
                  <span className="text-sm font-semibold text-blue-700">
                    #{item?.rfqId}
                  </span>
                  <span className="truncate text-sm text-gray-700">
                    {item?.name || "Untitled RFQ"}
                  </span>
                  <span className="truncate text-sm text-gray-600">
                    {item?.businessDivision || "--"}
                  </span>
                  <span className="truncate text-sm text-gray-600" title={item?.projectName || ""}>
                    {item?.projectName || "--"}
                  </span>
                  <span className="text-right text-sm font-semibold text-gray-900">
                    {formatCurrency(item?.amount || 0)}
                  </span>
                </button>
              ))}
              <div className="grid min-w-[760px] grid-cols-[90px_1.25fr_1fr_1.25fr_120px] gap-3 border-t border-gray-200 bg-gray-50 px-4 py-3">
                <span />
                <span />
                <span className="text-right text-sm font-bold text-gray-900">
                  
                </span>
                <span className="text-right text-sm font-bold text-gray-900">Total</span>
                <span className="text-right text-sm font-bold text-gray-900">
                  {formatCurrency(orderValuePopup.total)}
                </span>
              </div>
            </div>
          </div>
        ) : (
          <p className="text-sm text-gray-500">
            No awarded order values found for this vendor.
          </p>
        )}
      </StaticPopup>

      <StaticPopup
        openModal={documentsPopup.open}
        handleClose={closeDocumentsPopup}
        header={`Documents${documentsPopup.companyName ? ` - ${documentsPopup.companyName}` : ""}`}
        width={"4xl"}
      >
        {documentsPopup.documents?.length ? (
          <div className="max-h-[360px] overflow-y-auto pr-1">
            <div className="grid grid-cols-[70px_minmax(0,1fr)_190px] items-center gap-3 rounded-t-md border border-gray-200 bg-gray-50 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
              <span>Sr No.</span>
              <span>Document</span>
              <span className="text-right">Actions</span>
            </div>
            {documentsPopup.documents.map((document, index) => {
              const extension = getDocumentExtension(document?.Name);

              return (
                <div
                  key={`${document?.Name || "document"}-${index}`}
                  className="grid grid-cols-[70px_minmax(0,1fr)_190px] items-center gap-3 border-x border-b border-gray-200 bg-white px-4 py-3"
                >
                  <span className="text-sm text-gray-600">{index + 1}</span>

                  <div className="flex min-w-0 items-center gap-2">
                    <img
                      src={`/assets/icons/${extension}.png`}
                      alt={extension}
                      className="h-5 w-5 flex-shrink-0"
                      onError={(event) => {
                        event.currentTarget.src = "/assets/icons/pdf.png";
                      }}
                    />
                    <span
                      className="truncate text-sm font-medium text-gray-700"
                      title={document?.Name}
                    >
                      {document?.Name || `Document ${index + 1}`}
                    </span>
                  </div>

                  <div className="flex shrink-0 items-center justify-end gap-2">
                    <button
                      type="button"
                      className="inline-flex items-center gap-1 rounded border border-blue-200 px-2 py-1 text-xs font-medium text-blue-700 hover:bg-blue-50"
                      onClick={() => viewDocument(document)}
                    >
                      <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
                        <circle cx="12" cy="12" r="3" />
                      </svg>
                      View
                    </button>
                    <button
                      type="button"
                      className="inline-flex items-center gap-1 rounded border border-green-200 px-2 py-1 text-xs font-medium text-green-700 hover:bg-green-50"
                      onClick={() => downloadDocument(document)}
                    >
                      <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M12 3v12" />
                        <path d="m7 10 5 5 5-5" />
                        <path d="M5 21h14" />
                      </svg>
                      Download
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-sm text-gray-500">
            No documents uploaded for this vendor.
          </p>
        )}
      </StaticPopup>

      <WarningPopup
        openModal={deleteVendorPopup.open}
        handleClosePopup={closeDeleteVendorPopup}
        handleSubmit={handleDeleteVendor}
        warningText={`Are you sure you want to delete ${deleteVendorPopup.companyName || "this vendor"}?`}
        loading={deleteVendorLoading}
      />

      <StaticPopup
        openModal={vendorTypePopupOpen}
        handleClose={() => setVendorTypePopupOpen(false)}
        header={"Categories"}
        width={"4xl"}
      >
        <VendorMakeSelections
          selections={getVendorMakeSelections(selectedVendorTypeDetails)}
        >
        {(renderMakeSelection) => selectedVendorTypeDetails?.length ? (
          <div className="space-y-4">
            {selectedVendorTypeDetails.map((typeEntry, typeIndex) => (
              <div
                key={`${typeEntry?.vendorType}-${typeIndex}`}
                className="overflow-hidden rounded-xl border border-[#DDE3EC] bg-white p-4"
              >
                <p className="rounded-lg bg-gradient-to-r from-[#FFF0E4] via-[#FFF8F1] to-[#F3F6FF] px-3 py-2 text-sm font-semibold text-[#1F2937]">
                  {typeEntry?.vendorType || "--"}
                </p>

                {typeEntry?.disciplines?.length ? (
                  <div className="mt-3 space-y-3">
                    {typeEntry.disciplines.map(
                      (discipline, disciplineIndex) => (
                        <div
                          key={`${discipline?.id || discipline?.name}-${disciplineIndex}`}
                          className="rounded-lg border border-[#E7E2F8] border-l-4 border-l-[#8B5CF6] bg-white p-3"
                        >
                          <p className="text-xs font-semibold text-[#6D28D9]">
                            {discipline?.name || "--"}
                          </p>

                          {discipline?.categories?.length ? (
                            <div className="mt-2 space-y-2">
                              {discipline.categories.map(
                                (category, categoryIndex) => (
                                  <div
                                    key={`${category?.id || category?.name}-${categoryIndex}`}
                                    className="rounded-lg border border-[#DBEAFE] bg-[#F8FBFF] p-3"
                                  >
                                    <p className="text-xs font-semibold text-[#1D4ED8]">
                                      {category?.name || "--"}
                                    </p>

                                    {category?.subCategories?.length ? (
                                      <div className="mt-2 flex flex-wrap gap-2">
                                        {category.subCategories.map(
                                          (
                                            subCategory,
                                            subCategoryIndex,
                                          ) => typeEntry?.vendorType === "Material" && subCategory?.makeIds?.length > 0 ? (
                                            <div
                                              key={`${subCategory?.id || subCategory?.name}-${subCategoryIndex}`}
                                              className="min-w-[240px] flex-1 rounded-lg border border-[#D1FAE5] bg-white p-2.5"
                                            >
                                              <span className="inline-flex rounded-full border border-[#D1FAE5] bg-[#ECFDF5] px-2.5 py-1 text-[11px] font-semibold text-[#047857]">
                                                {subCategory?.name || "--"}
                                              </span>
                                              <div className="mt-2 flex flex-wrap items-center gap-1.5">
                                                <span className="mr-1 text-[10px] font-semibold uppercase tracking-wide text-[#C2410C]">
                                                  Makes / Brands
                                                </span>
                                                {renderMakeSelection(subCategory.id, { summary: true })}
                                              </div>
                                            </div>
                                          ) : (
                                            <span
                                              key={`${subCategory?.id || subCategory?.name}-${subCategoryIndex}`}
                                              className="rounded-full border border-[#D1FAE5] bg-[#ECFDF5] px-2.5 py-1 text-[11px] font-medium text-[#047857]"
                                            >
                                              {subCategory?.name || "--"}
                                            </span>
                                          ),
                                        )}
                                      </div>
                                    ) : (
                                      <p className="mt-2 text-[11px] text-gray-400">
                                        No sub-categories added
                                      </p>
                                    )}
                                  </div>
                                ),
                              )}
                            </div>
                          ) : (
                            <p className="mt-2 text-[11px] text-gray-400">
                              No categories added
                            </p>
                          )}
                        </div>
                      ),
                    )}
                  </div>
                ) : (
                  <p className="mt-2 text-xs text-gray-400">
                    No disciplines added
                  </p>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-gray-500">
            No vendor categories available for this vendor.
          </p>
        )}
        </VendorMakeSelections>
      </StaticPopup>

      {/* add manually */}
      <VendorFormDrawer
        open={openAddVendorPopup}
        onClose={() => setOpenAddVendorPopup(false)}
        header="Edit Vendor"
      >
        <VendorInvitationForm
          user={userProfile}
          editVendorDetails={editVendorDetails}
          isEdit={true}
          isApprovalMode={false}
          isPopupView={true}
          submissionSource="MANUAL"
          onFormReady={(api) => setApprovalFormApi(api)}
        />

        {/* FOOTER BUTTONS */}
        <div className="bg-white border-t border-gray-200 flex justify-end gap-3 px-4 py-3">
          {/* Delete Button */}
          <button
            onClick={async () => {
              if (!approvalFormApi?.deleteVendor) return;

              try {
                await approvalFormApi.deleteVendor();
                setSnackbarSeverity("success");
                setSnackbarText("Vendor deleted successfully!");
                setSnackbarOpen(true);

                dispatch(
                  filterCompanyDirectory({
                    filterData: appliedFilters,
                    searchKey: searchValue,
                    pageNum: 1,
                    userId,
                    entityId,
                  }),
                );

                setOpenAddVendorPopup(false);
              } catch {
                setSnackbarSeverity("error");
                setSnackbarText("Error deleting vendor");
                setSnackbarOpen(true);
              }
            }}
            className="px-4 py-2 rounded-sm border border-red-500 text-red-500 text-xs font-medium hover:bg-red-50"
          >
            Delete Vendor
          </button>

          {/* Save Changes */}
          <button
            onClick={async () => {
              if (!approvalFormApi?.saveChanges) return;

              try {
                const result = await approvalFormApi.saveChanges();
                if (result?.error !== false || !result.payload?.vendorId) {
                  throw new Error("The vendor update was not confirmed. Please try again.");
                }
                setSnackbarSeverity("success");
                setSnackbarText("Vendor updated successfully!");
                setSnackbarOpen(true);

                dispatch(
                  filterCompanyDirectory({
                    filterData: appliedFilters,
                    searchKey: searchValue,
                    pageNum: 1,
                    userId,
                    entityId,
                  }),
                );

                setOpenAddVendorPopup(false);
              } catch (error) {
                setSnackbarSeverity("error");
                setSnackbarText(error?.response?.data?.message || error?.message || "Error saving changes");
                setSnackbarOpen(true);
              }
            }}
            className="px-4 py-2 rounded-sm bg-black text-white text-xs font-medium hover:shadow-md"
          >
            Save Changes
          </button>
        </div>
      </VendorFormDrawer>

      {openApprovalPopup && (
        <VendorFormDrawer
          open={openApprovalPopup}
          onClose={() => setOpenApprovalPopup(false)}
          header={
            approvalMode === "PENDING"
              ? "Review & Approve Vendor"
              : approvalMode === "APPROVED"
                ? "Edit Approved Vendor"
                : "Approve Archived Vendor"
          }
        >
          {/* FORM */}
          <VendorInvitationForm
            key={pendingVendorData?.vendorId}
            user={userProfile}
            editVendorDetails={pendingVendorData}
            isEdit={true}
            isApprovalMode={true}
            approvalMode={approvalMode}
            onFormReady={(api) => setApprovalFormApi(api)}
            submissionSource="INVITATION"
          />

          {/* ACTION BUTTONS (OUTSIDE FORM) */}
          <div className=" bg-white border-t border-gray-200 flex justify-end gap-3 px-4 py-3 z-20">
            {/* Reject → ONLY for PENDING */}
            {approvalMode === "PENDING" && (
              <button
                onClick={async () => {
                  if (!approvalFormApi?.rejectVendor) return;

                  try {
                    await approvalFormApi.rejectVendor();
                    setSnackbarSeverity("warning");
                    setSnackbarText("Vendor rejected.");
                    setSnackbarOpen(true);

                    dispatch(
                      filterCompanyDirectory({
                        filterData: { isApproved: false },
                        searchKey: "",
                        pageNum: 1,
                        userId,
                        entityId,
                      }),
                    );

                    setOpenApprovalPopup(false);
                  } catch {
                    setSnackbarSeverity("error");
                    setSnackbarText("Error rejecting vendor");
                    setSnackbarOpen(true);
                  }
                }}
                className="px-4 py-2 rounded-sm text-black text-xs font-medium border border-black"
              >
                Reject
              </button>
            )}

            {/* Approve → PENDING + ARCHIVED */}
            {(approvalMode === "PENDING" || approvalMode === "ARCHIVED") && (
              <button
                onClick={async () => {
                  if (!approvalFormApi?.approveVendor) return;

                  try {
                    await approvalFormApi.approveVendor();
                    setSnackbarSeverity("success");
                    setSnackbarText("Vendor approved successfully!");
                    setSnackbarOpen(true);

                    dispatch(
                      filterCompanyDirectory({
                        filterData: { isApproved: false },
                        searchKey: "",
                        pageNum: 1,
                        userId,
                        entityId,
                      }),
                    );

                    setOpenApprovalPopup(false);
                  } catch {
                    setSnackbarSeverity("error");
                    setSnackbarText("Error approving vendor");
                    setSnackbarOpen(true);
                  }
                }}
                className="px-4 py-2 rounded-sm bg-black text-white text-xs font-medium hover:shadow-md"
              >
                Approve
              </button>
            )}

            {/* Save Changes → ONLY for APPROVED */}
            {approvalMode === "APPROVED" && (
              <button
                onClick={async () => {
                  if (!approvalFormApi?.saveChanges) return;

                  try {
                    const result = await approvalFormApi.saveChanges();
                    if (result?.error !== false || !result.payload?.vendorId) {
                      throw new Error("The vendor update was not confirmed. Please try again.");
                    }
                    setSnackbarSeverity("success");
                    setSnackbarText("Vendor updated successfully!");
                    setSnackbarOpen(true);

                    dispatch(
                      filterCompanyDirectory({
                        filterData: { approvedByUserId: userId },
                        searchKey: "",
                        pageNum: 1,
                        userId,
                        entityId,
                      }),
                    );

                    setOpenApprovalPopup(false);
                  } catch (error) {
                    setSnackbarSeverity("error");
                    setSnackbarText(error?.response?.data?.message || error?.message || "Error saving changes");
                    setSnackbarOpen(true);
                  }
                }}
                className="px-4 py-2 rounded-sm bg-black text-white text-xs font-medium hover:shadow-md"
              >
                Save Changes
              </button>
            )}
          </div>
        </VendorFormDrawer>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          icon={false}
          severity={snackbarSeverity}
          onClose={() => setSnackbarOpen(false)}
        >
          {snackbarText}
        </MuiAlert>
      </Snackbar>
    </section>
  );
};

export default TableComponent;
